import { FormDataAPIType } from 'components/common/form';
import React from 'react';
import ReactHookFormController from 'components/common/form/layout/ReactHookFormController';
import BlockEditPanelControls from 'app/editor/report/content-editor/block-edit-panel/BlockEditPanelControls';
import useBundleTranslation from 'i18n';
import useCustomSimplifiedForm from 'components/common/form/hooks/useCustomSimplifiedForm';
import { prepareFormElementProps } from 'components/common/form/formTools';
import { Box, Stack } from '@mui/material';
import BlockEditPanelHeader from 'app/editor/report/content-editor/block-edit-panel/BlockEditPanelHeader';
import EditPanelCheckBox from 'app/editor/report/content-editor/block-edit-panel/edit-panel-components/EditPanelCheckBox';
import { type ComponentSettingsKpiChartMeasureField } from '@report-content';

export default function MeasureFieldForm({
    field,
    onApply,
    onCancel,
    title,
}: {
    field: ComponentSettingsKpiChartMeasureField;
    onApply: (field: ComponentSettingsKpiChartMeasureField) => void;
    onCancel: () => void;
    title: string;
}) {
    const elementProps: FormDataAPIType = useCustomSimplifiedForm({
        custom_label: field.custom_label ?? '',
        show_data_labels: field.show_data_labels ?? 'N',
    });
    const { t } = useBundleTranslation(['components/report-content']);

    return (
        <Stack height={1}>
            <Box flexShrink={0}>
                <BlockEditPanelHeader title={title} onCancel={() => onCancel()} item={field.column_name} />
            </Box>
            <Stack sx={{ overflow: 'auto', flexGrow: 1, p: 3 }} spacing={2}>
                <Box>
                    <ReactHookFormController
                        elementProps={prepareFormElementProps({
                            ...elementProps,
                            component: {
                                component: 'FormText',
                                label: t('kpi_chart.measure_label'),
                                name: 'custom_label',
                                props: { placeholder: field.column_name },
                            },
                        })}
                    />
                </Box>
                <Box>
                    <EditPanelCheckBox
                        elementProps={elementProps}
                        name={'show_data_labels'}
                        label={t('kpi_chart.display_values_on_chart')}
                    />
                </Box>
            </Stack>
            <Box flexShrink={0}>
                <BlockEditPanelControls
                    onApply={() => {
                        onApply({
                            ...field,
                            ...elementProps.form.hookFormGetValues(),
                        });
                    }}
                    onCancel={() => onCancel()}
                    isTypeSave
                />
            </Box>
        </Stack>
    );
}
